import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';

import useDialog from 'hooks/useDialog';
import useExclusiveOffer from 'hooks/useExclusiveOffer';

import { sendEvent } from 'lib/gtag';
import { toOfferRedirectLink } from 'lib/links';
import placeholder from 'lib/placeholder';
import { getUtmsFromSession } from 'lib/sessionStorage';

const CouponDialog = dynamic(() => import('./CouponDialog'), {
  ssr: false,
});

const getUtmsAsSearchParam = () =>
  new URLSearchParams(getUtmsFromSession()).toString();

const GoToStoreButton = ({
  className,
  gaEventCategory,
  gaEventCategoryPostfix,
  offerCta = null,
  offerCoupon = null,
  offerId,
  offerUserVisibility,
}) => {
  const { showDialog } = useDialog();
  const { isOfferBlocked } = useExclusiveOffer();

  const utms = getUtmsAsSearchParam();

  if (offerCoupon) {
    return (
      <Button
        className={className}
        disabled={isOfferBlocked(offerUserVisibility)}
        size="size1"
        type="primary"
        full
        onClick={() => {
          sendEvent({
            action: 'modal_coupon_open',
            category: 'active_offer_buy',
            label: offerCta ?? placeholder('actions.goToStore'),
          });
          showDialog(CouponDialog, {
            offerCta,
            offerCoupon,
            offerId,
            utms,
            gaEventCategoryPostfix,
          });
        }}
      >
        {offerCta ?? placeholder('actions.goToStore')}
      </Button>
    );
  }

  return (
    <Button
      as="a"
      className={className}
      disabled={isOfferBlocked(offerUserVisibility)}
      href={toOfferRedirectLink(offerId, utms)}
      size="size1"
      target="_blank"
      type="primary"
      full
      onClick={() => {
        sendEvent({
          action: 'go_store',
          category: `${gaEventCategory}${
            gaEventCategoryPostfix ? `_${gaEventCategoryPostfix}` : ''
          }`,
          label: offerCta ?? placeholder('actions.goToStore'),
        });
      }}
    >
      {offerCta ?? placeholder('actions.goToStore')}
    </Button>
  );
};

GoToStoreButton.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  gaEventCategoryPostfix: PropTypes.string,
  offerCta: PropTypes.string,
  offerCoupon: PropTypes.string,
  offerId: PropTypes.number.isRequired,
  offerUserVisibility: PropTypes.string.isRequired,
};

export default GoToStoreButton;
